import { render, staticRenderFns } from "./bindParts.vue?vue&type=template&id=14535940&"
import script from "./bindParts.vue?vue&type=script&lang=js&"
export * from "./bindParts.vue?vue&type=script&lang=js&"
import style0 from "./../Setting/setting.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports